import React, { useEffect, useRef, useState } from "react";
import { Field, formValueSelector, reduxForm, reset } from "redux-form";
import s from "./pulse.module.css";
import { connect } from "react-redux";
import { getFetch, getMessage } from "../../redux/Chat_reducer";
import Loader from "../Loaders/Loader";
import MessageSuccess from "../Messages/MessageSuccess";
import { phoneMask } from "../utils";



let DialogForm = ({
  fetch,
  handleSubmit,
  hasMail,
  hasPhone,
  hasQ,
  active,
  dispatch,
  message,
}) => {
  const [messageWindowToggle, setMessageWindowToggle] = useState(false);
  const disabled = !(!!hasMail && !!hasQ && hasPhone?.length === 10);

  useEffect(() => {
    if (message.length > 0) {
      setMessageWindowToggle(true);
      dispatch(reset("pulseForm"));
    } else {
      setMessageWindowToggle(false);
    }
  }, [dispatch, message]);
  const ref = useRef<Field>();
  useEffect(() => {
    if (active) {
      ref.current?.ref.current?.ref.current?.focus?.();
    }
  }, [active]);
  return (
    (messageWindowToggle && <MessageSuccess message={message} />) ||
    (fetch ? (
      <Loader />
    ) : (
      <form className={s.form} onSubmit={handleSubmit}>
        <span>Задайте нам вопрос</span>
        <Field
          ref={ref}
          forwardRef
          placeholder={"E-mail"}
          component={"input"}
          type={"text"}
          name={"email"}
        />
        <Field
          placeholder={"Телефон"}
          component={"input"}
          type={"tel"}
          {...phoneMask}
          name={"phone"}
        />
        <Field
          placeholder={"Вопрос"}
          component={"textarea"}
          rows={"10"}
          name={"question"}
        />
        <button disabled={disabled}>Отправить</button>
      </form>
    ))
  );
};

DialogForm = reduxForm({
  form: "pulseForm",
})(DialogForm);

const selector = formValueSelector("pulseForm");

export default connect((state) => ({
  hasMail: selector(state, "email"),
  hasPhone: selector(state, "phone"),
  hasQ: selector(state, "question"),
  message: getMessage(state),
  fetch: getFetch(state),
}))(DialogForm);
